import { motion } from "framer-motion";

/**
 * Presents real product photography (shot on white) inside a deliberate,
 * bright "studio pod" so the white backdrop blends seamlessly against the
 * dark page. A coloured glow sits behind the frame for brand accent.
 */
export const StudioFrame = ({
  src,
  alt,
  glow = "#E53935",
  float = false,
  blend = true,
  dark = false,
  className = "",
  imgClassName = "",
  rounded = "rounded-[28px]",
}) => (
  <div className={`relative ${className}`}>
    <div
      className="pointer-events-none absolute inset-0 -z-10 translate-y-6 scale-110 rounded-full blur-3xl"
      style={{ background: `radial-gradient(circle, ${glow}44, transparent 65%)` }}
    />
    <div
      className={`relative overflow-hidden border ${dark ? "border-white/10" : "border-avatar-ink/10"} ${rounded}`}
      style={{
        background: dark
          ? "#0b0b0b"
          : "radial-gradient(120% 90% at 50% 20%, #ffffff 0%, #f3f5f7 55%, #e6eaee 100%)",
        boxShadow: dark
          ? "0 40px 90px rgba(0,0,0,0.6)"
          : "0 40px 90px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.8)",
      }}
    >
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        animate={float ? { y: [0, -12, 0] } : {}}
        transition={float ? { duration: 6, repeat: Infinity, ease: "easeInOut" } : {}}
        className={`mx-auto block w-full object-contain ${imgClassName}`}
        style={blend ? { mixBlendMode: "multiply" } : undefined}
      />
      {/* studio floor shadow */}
      {!dark && (
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/5 to-transparent" />
      )}
    </div>
  </div>
);
